module.exports = __webpack_public_path__ + "img/visa.2fc6aa80.svg";